module.exports = __webpack_public_path__ + "img/theme_hillendell.3f7475d6.png";